enum DFWeaponType {
  SMG = "SMG",
  LMG = "LMG",
  Pistol = "Pistol",
  Shotgun = "Shotgun",
  SniperRifle = "SniperRifle",
  AssaultRifle = "AssaultRifle",
  MarksmanRifle = "MarksmanRifle",
}

export default DFWeaponType;
